import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  fill: "none",
  viewBox: "0 0 18 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#b26b00",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m4.5 3.75 3.375 3.375M4.5 3.75H2.25L1.5 1.5l.75-.75 2.25.75zm9.944-2.444-1.97 1.97c-.297.297-.446.446-.502.617a.75.75 0 0 0 0 .464c.056.171.205.32.502.617l.178.177c.297.297.445.446.616.502a.75.75 0 0 0 .464 0c.171-.056.32-.205.617-.502l1.843-1.843a4.125 4.125 0 0 1-4.62 5.614c-.364-.072-.547-.108-.657-.097a.6.6 0 0 0-.28.085c-.098.053-.196.15-.392.347l-5.368 5.368a1.591 1.591 0 0 1-2.25-2.25l5.368-5.368c.196-.196.294-.294.347-.392a.6.6 0 0 0 .085-.28c.01-.11-.025-.293-.097-.657a4.125 4.125 0 0 1 6.116-4.372M9 10.5l4.125 4.125a1.591 1.591 0 0 0 2.25-2.25L11.982 8.98a4 4 0 0 1-.701-.128c-.292-.08-.612-.022-.826.192z"
    }, null, -1)
  ]))]))
}
export default { render: render }